/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

const baseUrl = 'trials';
const pathParameterPlaceholder = undefined;
function freeze(value) {
  return Object.freeze(value);
}

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * get-/trials/v1/hub-trials/app/active
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:HubTrialsAppResource+type:symbol+getActiveHubTrialsByHubId&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Hub_Trials_App-get-%2Ftrials%2Fv1%2Fhub-trials%2Fapp%2Factive'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Ftrials%2Fv1%2Fhub-trials%2Fapp%2Factive?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getActiveHubTrialsByHubIdRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v1/hub-trials/app/active'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * get-/trials/v1/hub-trials/app/name/all
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:HubTrialsAppResource+type:symbol+getActiveTrialNames&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Hub_Trials_App-get-%2Ftrials%2Fv1%2Fhub-trials%2Fapp%2Fname%2Fall'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Ftrials%2Fv1%2Fhub-trials%2Fapp%2Fname%2Fall?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getActiveTrialNamesRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v1/hub-trials/app/name/all'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * get-/trials/v1/hub-trials/app/all
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:HubTrialsAppResource+type:symbol+getAllHubTrialsByHubId&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Hub_Trials_App-get-%2Ftrials%2Fv1%2Fhub-trials%2Fapp%2Fall'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Ftrials%2Fv1%2Fhub-trials%2Fapp%2Fall?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getAllHubTrialsByHubIdRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v1/hub-trials/app/all'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * get-/trials/v1/experiment-date/{experimentId}
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:ExperimentDateResource+type:symbol+getExperimentDate&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Experiment_Date-get-%2Ftrials%2Fv1%2Fexperiment-date%2F%7BexperimentId%7D'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Ftrials%2Fv1%2Fexperiment-date%2F%28%28%7BexperimentId%7D%29%29?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getExperimentDateRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v1/experiment-date', pathParameterPlaceholder]),
  pathParameters: freeze(['experimentId'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * get-/trials/v1/hub-trials/app/audit
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:HubTrialsAppResource+type:symbol+getHubTrialsDetailedAudit&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Hub_Trials_App-get-%2Ftrials%2Fv1%2Fhub-trials%2Fapp%2Faudit'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Ftrials%2Fv1%2Fhub-trials%2Fapp%2Faudit?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getHubTrialsDetailedAuditRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v1/hub-trials/app/audit'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * get-/trials/v1/json/{lookupKey}
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:JsonBlobsResource+type:symbol+getJsonBlobByKey&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Json_Blobs-get-%2Ftrials%2Fv1%2Fjson%2F%7BlookupKey%7D'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Ftrials%2Fv1%2Fjson%2F%28%28%7BlookupKey%7D%29%29?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getJsonBlobByKeyRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v1/json', pathParameterPlaceholder]),
  pathParameters: freeze(['lookupKey'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * get-/trials/v1/json/for-portal/{lookupKey}
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:JsonBlobsResource+type:symbol+getPortalJsonBlobByKey&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Json_Blobs-get-%2Ftrials%2Fv1%2Fjson%2Ffor-portal%2F%7BlookupKey%7D'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Ftrials%2Fv1%2Fjson%2Ffor-portal%2F%28%28%7BlookupKey%7D%29%29?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getPortalJsonBlobByKeyRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v1/json/for-portal', pathParameterPlaceholder]),
  pathParameters: freeze(['lookupKey'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * get-/trials/v1/trial-guide-preferences/{trialId}
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:TrialGuidePreferencesResource+type:symbol+getTrialGuidePreference&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Trial_Guide_Preferences-get-%2Ftrials%2Fv1%2Ftrial-guide-preferences%2F%7BtrialId%7D'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Ftrials%2Fv1%2Ftrial-guide-preferences%2F%28%28%7BtrialId%7D%29%29?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getTrialGuidePreferenceRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v1/trial-guide-preferences', pathParameterPlaceholder]),
  pathParameters: freeze(['trialId'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * post-/trials/v1/hub-trials/app/start
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:HubTrialsAppResource+type:symbol+startHubTrials&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Hub_Trials_App-post-%2Ftrials%2Fv1%2Fhub-trials%2Fapp%2Fstart'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/post/api.hubapi.com%2Ftrials%2Fv1%2Fhub-trials%2Fapp%2Fstart?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const postHubTrialStartRpc = freeze({
  baseUrl,
  method: 'post',
  pathSegments: freeze(['v1/hub-trials/app/start'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * put-/trials/v1/json
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:JsonBlobsResource+type:symbol+upsertJsonBlob&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Json_Blobs-put-%2Ftrials%2Fv1%2Fjson'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/put/api.hubapi.com%2Ftrials%2Fv1%2Fjson?showRequestDetails=true&body=%7B%22lookupKey%22:%22string%22,%22jsonData%22:%7B%7D%7D&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const upsertJsonBlobRpc = freeze({
  baseUrl,
  method: 'put',
  pathSegments: freeze(['v1/json'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * put-/trials/v1/json/for-portal
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:JsonBlobsResource+type:symbol+upsertPortalJsonBlob&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Json_Blobs-put-%2Ftrials%2Fv1%2Fjson%2Ffor-portal'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/put/api.hubapi.com%2Ftrials%2Fv1%2Fjson%2Ffor-portal?showRequestDetails=true&body=%7B%22lookupKey%22:%22string%22,%22jsonData%22:%7B%7D%7D&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const upsertPortalJsonBlobRpc = freeze({
  baseUrl,
  method: 'put',
  pathSegments: freeze(['v1/json/for-portal'])
});